// extracted by mini-css-extract-plugin
module.exports = {"loading":"styles_loading_mos0uFOkw2Lz10LiZ1458","spinner":"styles_spinner_3wB1ZAQQ85nMS1DAZwc8Nl"};